export default __webpack_public_path__ + "static/media/img2.00d753c9.jpg";